export class MatrixFilter {
    type: string;
    event: any;

    constructor(type: string, event: any) {
        this.type = type;
        this.event = event;
    }
}